import { type Brands } from '@landsbankinn/ui-kit';
import { useApplicationServerContext } from 'src/state';

export function useBrand(): Brands | undefined {
  const [{ uiTheme }] = useApplicationServerContext();
  return uiTheme as Brands;
}
